module.exports = {
  "inputBox": {
    "display": "flex",
    "flexDirection": "row",
    "position": "relative",
    "alignItems": "stretch",
    "overflow": "hidden"
  },
  "input": {
    "flex": 1,
    "paddingLeft": "32",
    "placeholderColor": "#c7c7cc"
  },
  "right": {
    "paddingRight": "30",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "clearImg": {
    "width": "48",
    "height": "48"
  },
  "PWDImg": {
    "width": "48",
    "height": "48",
    "marginLeft": "10"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6078d0a7!./~/weex-vue-loader/lib/selector.js?type=styles&index=1!./packages/dof-input/index.vue
// module id = 499
// module chunks = 0 1